export const environment = {
  production: false,
  apiUrl: 'https://staging.api.bidarbak.com/api',
  debug: true,
  googleMapsApiKey: 'AIzaSyCdJbSJ67ekuYi65nuDrFO2xsGcKBIBNII',
  firebase: {
    apiKey: 'AIzaSyC28sRYH9iplXa12Ci4AIBMfwZJ9BDntQk',
    authDomain: 'bidarbak-713ff.firebaseapp.com',
    projectId: 'bidarbak-713ff',
    storageBucket: 'bidarbak-713ff.firebasestorage.app',
    messagingSenderId: '317830624293',
    appId: '1:317830624293:web:4d566e402839b6f999bbcc',
    measurementId: 'G-BV611B9GDR',
    vapidKey:
      'BOMKKfF5p1CXDq4N1q_g-M0z7wbyxMwfEGya-8jjptPkw5WqDinIpJQMgfIllkaaBbf7FjJLSZJawSNCKl-ZRs8', // Generate in Firebase → Project Settings → Cloud Messaging → Web Push
  },
};
